export default __webpack_public_path__ + "static/media/projects.6fb6fd55.png";